{
    "SymbolLabel": "Simbolo:",
    "SymbolNote": "(Applica automaticamente le modifiche ai campi sottostanti)",
    "PatternLabel": "Modello:",
    "GroupingseparatorLabel": "Separatore di raggruppamento:",
    "GroupingseparatorOptionCommaDesc": "(virgola)",
    "GroupingseparatorOptionSpaceDesc": "(Spazio)",
    "GroupingseparatorOptionFullstopDesc": "(Arresto completo)",
    "DecimalseparatorLabel": "Separatore decimale:",
    "DecimalseparatorOptionFullstopDesc": "(Arresto completo)",
    "DecimalseparatorOptionColonDesc": "(Colon)",
    "DecimalseparatorOptionCommaDesc": "(virgola)",
    "PreviewLabel": "Anteprima",
    "CurrencyDisplayFormat_SectionHeader": "Formato di visualizzazione della valuta",
    "NAME": "CurrencyDisplayFormat"
}